
<div class="container">
    <div class="main-header">
        <slot name="main-header" />
    </div>
    <div class="main-buttons">
        <slot name="main-buttons"/>
    </div>
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
    }
    .main-header {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        flex: 1 1 66%;
        font-size: var(--font-size-page-header);
    }
    .main-buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        flex: 1 1 33%;
    }

</style>
